<div class="p-3">
  <h2 class="fw-bold">Check Unsubmitted Reserve Group</h2>

  <table class="table table-bordered table-custom">
    <thead>
      <tr>
        <td>ID</td>
        <td>Customer Details</td>
        <td>Requested By</td>
        <td>Details</td>
      </tr>
    </thead>
    <tbody>
      @for (rg of rgList; track rg) {
        <tr>
          <td>{{ rg.ID }}</td>
          <td>{{ rg?.customer?.CustomerName }} | {{ rg?.customer?.ICNumber || "" }}</td>
          <td>{{ rg.RequestedOn | date: "dd-MM-yyyy" }} by {{ rg.RequestedBy }}</td>
          <td>
            <btn class="btn btn-warning" (click)="goToReserveGroup(rg.ID)">Check</btn>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
